<template>
   <v-form ref="form" v-model="valid">
    <v-layout align-end justify-center>
      <v-textarea
          v-if="multiline"
          :rules="evaluateLength ? [formRules.description] : []"
          :label="label"
          append-icon="edit"
          hide-details="auto"
          xs12
          :class="textClass"
          color="primary"
          rows="1"
          auto-grow
          v-model="editingText"
        />
        <v-text-field
          v-else
          :label="label"
          append-icon="edit"
          hide-details="auto"
          :rules="evaluateLength ? [formRules.required, formRules.title] : [formRules.required]"
          xs12
          :class="textClass"
          color="primary"
          v-model="editingText"
        />
  
      <v-fade-transition>
        <v-btn class=" ml-2 mr-2" dark color="disabled" v-show="textHasChanged" @click="didTapRevert">
          <v-icon>undo</v-icon>
        </v-btn>
      </v-fade-transition>
      <v-fade-transition>
        <v-btn color="primary" v-show="shouldShow" @click="didTapSave">Salvar</v-btn>
      </v-fade-transition>
    </v-layout>
    </v-form>
</template>

<script>

import FormRules from "@/utils/formRules.js";

export default {
  mixins: [FormRules],
  data: () => ({
    editingText: '',
    valid: true,
  }),

  /*
    Após o método 'created' e antes do método 'mounted' as regras do formulário
    já são avaliadas, mesmo o editingText ainda sendo undefined. Isso gera
    um erro. Por isso, fez-se necessário atribuir valor ao editingText an-
    tes da avaliação.
  */ 
  beforeMount(){
    this.editingText = ''
  },

  watch: {
    text: {
      immediate: true,
      handler(v) {
        this.editingText = v;
      }
    },

    editingText() {
      this.$refs.form.validate();
    },
  },
  props: {
    evaluateLength: { type: Boolean, default: true},
    text: String,
    multiline: Boolean,
    label: String,
    textClass: String
  },
  computed: {

    textHasChanged() {
      return this.editingText.trim() !== this.text;
    },
    shouldShow() {
      return this.valid && this.textHasChanged
    }
  },
  methods: {
    didTapRevert() {
      this.editingText = this.text;
    },
    didTapSave() {
        this.$emit("didTapSave", this.editingText.trim());
    }
  }
};
</script>